<!-- The upload-dialog pattern (Figma 12547:40446, Upload changes): heading, underline fields, an outlined Upload file
     button with the picked file's name, and one full-width Submit. A PDF dropped anywhere on the dialog is picked too. -->
<div class="wrapper flex flex-col" [class.wrapper--dragging]="dragging" (dragover)="over($event)" (dragleave)="dragging = false" (drop)="drop($event)">
  <div class="heading text-type-1" [ngClass]="{ 'mb-[20px]': !data.sheet }">Upload drawing set</div>
  @if (data.sheet) {
    <!-- W65: page 1 of this PDF becomes the sheet's next revision -->
    <p class="subtitle mat-body-1 mb-[20px]" data-testid="drawings-upload-revision-of">New revision of {{ data.sheet.label }}</p>
  }

  <form class="flex flex-col gap-[calc(40px-1.25em)]" [formGroup]="form">
    <app-text-input data-testid="drawings-upload-name" [parentFormGroup]="form" controlName="name" label="SET NAME" placeholder="e.g. IFC set" [maxLength]="256" />
    <app-date-picker data-testid="drawings-upload-issued" [parentFormGroup]="form" controlName="issuedAt" label="ISSUED DATE" placeholder="Select a date" />
  </form>

  <div class="hint text-type-10 mb-[12px]" data-testid="drawings-upload-hint">
    {{ data.sheet ? 'Page 1 becomes the new revision; any other pages come in skipped.' : 'One sheet per page. Upload the PDF as issued.' }}
  </div>

  @if (file) {
    <div class="file-name flex flex-row justify-start items-center gap-[5px] mb-[12px] italic" data-testid="drawings-upload-file">
      <span class="underline underline-offset-4">{{ file.name }}</span>
      @if (!submitting) {
        <mat-icon class="close-icon" role="button" aria-label="Remove file" (click)="removeFile()">close</mat-icon>
      }
    </div>
  }
  <div>
    <button type="button" class="upload-btn" color="primary" mat-stroked-button data-testid="drawings-upload-pick" [disabled]="submitting" (click)="fileInput.click()">Upload file</button>
    <input #fileInput type="file" accept="application/pdf" class="input-files" data-testid="drawings-upload-file-input" (change)="pick(fileInput.files); fileInput.value = ''" />
  </div>

  @if (progress) {
    <div class="upload-progress flex flex-col gap-[8px] mt-[16px]" data-testid="drawings-upload-progress">
      <span class="upload-progress-label text-type-14" data-testid="drawings-upload-stage">{{ stageLabel }}</span>
      <mat-progress-bar color="primary" [mode]="progress.stage === 'finalizing' ? 'indeterminate' : 'determinate'" [value]="percent" />
    </div>
  }
  @if (error) { <div class="upload-error text-type-14 mt-[16px]" role="alert">{{ error }}</div> }

  <div class="actions mt-[calc(100px-1.25em)]">
    <app-primary-button buttonId="drawings-upload-submit" data-testid="drawings-upload-submit" [isLoading]="submitting" [isDisabled]="!file || submitting || form.invalid" (handleClick)="submit()">Submit</app-primary-button>
  </div>
</div>
